export * from "./AccommodationEditorLocation";
export * from "./AccommodationProfileLocation";
export * from "./ContractsPriceTemplateEditLocation";
export * from "./CustomerEditorLocation";
export * from "./CustomerProfileLocation";
export * from "./consultant-profile.location";
export * from "./ConsultantEditorLocation";
export * from "./ConsultantContractEditorLocation";
export * from "./ContractViewLocation";
export * from "./ConsultantBookingContractEditorLocation";
export * from "./BookingEditLocation";
export * from "./BookingProfileLocation";
export * from "./kit-profile-location";
export * from "./ContactPersonLocation";
export * from "./TicketProfileLocation";
export * from "./TicketCreateLocation";
export * from "./OrderCreateLocation";
export * from "./CustomerInvoiceLocation";
export * from "./CustomerContractSnapshotEditorLocation";
export * from "./CustomerContractSubVersionEditorLocation";

export const ACCOMMODATION_REQUEST_SLIDER = "accommodationRequestSlider";
export const TRAVEL_REQUEST_SLIDER = "travelRequestSlider";
export const BOOKING_SLIDER = "bookingSlider";
export const KIT_SLIDER = "KitSlider";
export const CONSULTANT_SLIDER = "consultantSlider";
export const CONSULTANT_CONTRACT_SLIDER = "consultantContractSlider";
export const CONSULTANT_BOOKING_CONTRACT_SLIDER = "consultantBookingContractSlider";
export const CUSTOMER_SLIDER = "customerSlider";
export const ACCOMMODATION_SLIDER = "accommodationSlider";
export const CUSTOMER_CONTRACT_SLIDER = "customerContractSlider";
export const CONTRACT_SLIDER = "contractSlider";
export const CONTRACT_CONTRACT_SNAPSHOT_SLIDER = "contractContractSnapshotSlider";
export const CONTRACT_CONTRACT_SUBVERSION_SLIDER = "contractContractSubVersionSlider";
export const CONTRACT_PRICE_TEMPLATE_SLIDER = "contractPriceTemplate";
export const TICKET_SLIDER = "ticketSlider";
export const ORDER_SLIDER = "orderSlider";
export const CUSTOMER_INVOICE_SLIDER = "customerInvoiceSlider";
export const SICK_FORM_SLIDER = "sickFormSlider";
